module.exports = __webpack_public_path__ + "img/palm2_2.b5a7372e.png";